var _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotifications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 30.5,
    stroke: "#03A438",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 24.5,
    fill: "white",
    stroke: "#03A438"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3882 27.9013C39.6078 28.9903 40.1132 30.0023 40.8532 30.8347C41.3133 31.5188 41.5798 32.3133 41.6248 33.1348V33.3904C41.6317 34.499 41.2345 35.5725 40.5065 36.4127C39.5839 37.3992 38.3321 38.0191 36.9839 38.1572C33.0007 38.6683 28.9678 38.6683 24.9846 38.1572C23.6206 38.0296 22.3511 37.4088 21.4173 36.4127C20.7122 35.5645 20.3424 34.49 20.3773 33.3904V33.1348C20.4209 32.3163 20.6792 31.5234 21.1265 30.8347C21.8698 30.0016 22.3824 28.9907 22.6138 27.9013C22.6474 27.4791 22.6474 27.054 22.6474 26.629C22.6474 26.204 22.6474 25.779 22.6809 25.3568C23.1059 21.3011 27.0199 18.501 30.9339 18.501H31.0458C34.9151 18.501 38.9074 21.3011 39.3211 25.3568C39.3547 25.7734 39.3547 26.1985 39.3547 26.6249C39.3547 27.0513 39.3547 27.4791 39.3882 27.9013ZM32.4552 39.8563C33.0769 39.8746 33.6873 40.0262 34.2445 40.3007H34.2781C34.7436 40.6806 34.8227 41.3585 34.457 41.8341C33.7911 42.7871 32.7255 43.388 31.5606 43.4675C30.3638 43.6102 29.1585 43.2789 28.2057 42.5453C27.7157 42.2092 27.3973 41.6778 27.3335 41.0896C27.3335 40.4674 27.915 40.1785 28.4518 40.0563C29.0805 39.9239 29.7214 39.8568 30.364 39.8563H32.4552Z",
    fill: "#03A438"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.48c71f42.svg";
export { ForwardRef as ReactComponent };